/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ActionMountField = core.serialization.object({
    keys: core.serialization.list(core.serialization.string()).optional(),
});
